module.exports = __webpack_public_path__ + "static/media/crfCardsAssetsNonPo.a2e56fd0.svg";